import {
  marketingEmailDataType,
  marketingPhoneCallDataType,
  marketingSmsDataType,
  personalDataMailCheckInput,
  personalDataPhoneCallCheckInput,
  personalDataSmsCheckInput,
  profilingDataInput,
  profilingDataType,
} from 'components/Privacy/Privacy.config';
import { InfoPrivacyFormValues } from 'components/Privacy/Privacy.types';
import {
  InfoPrivacy,
  InfoPrivacyRequestPayload,
} from 'services/privacy/privacy.types';

export type InfoPrivacyFormStateConfig = Readonly<{
  formValues: InfoPrivacyFormValues;
}>;

export function postContextSensitiveInfoPrivacyRequestData(
  config: Required<InfoPrivacyFormStateConfig>,
): InfoPrivacyRequestPayload {
  const { formValues } = config;
  const {
    [profilingDataInput]: profilingData,
    [personalDataMailCheckInput]: marketingEmailData,
    [personalDataSmsCheckInput]: marketingSmsData,
    [personalDataPhoneCallCheckInput]: marketingPhoneCallData,
  } = formValues;

  const checkVisionState = 1;

  const profilingDataObj = {
    checkVisionState,
    description: 'Profilazione',
    flag: profilingData,
    type: profilingDataType,
  } as InfoPrivacy;

  const emailDataObj = {
    checkVisionState,
    description: 'Marketing diretto (Email)',
    flag: marketingEmailData,
    type: marketingEmailDataType,
  } as InfoPrivacy;

  const smsDataObj = {
    checkVisionState,
    description: 'Marketing diretto (Sms)',
    flag: marketingSmsData,
    type: marketingSmsDataType,
  } as InfoPrivacy;

  const phoneCallDataObj = {
    checkVisionState,
    description: 'Marketing diretto (Chiamate)',
    flag: marketingPhoneCallData,
    type: marketingPhoneCallDataType,
  } as InfoPrivacy;

  return {
    infoPrivacyList: [
      profilingDataObj,
      emailDataObj,
      smsDataObj,
      phoneCallDataObj,
    ],
  } as InfoPrivacyRequestPayload;
}
